import Card from "../card";
import * as S from "../dashboard/_shared";
import "./style.scss";

export default function Section({
  title,
  action,
  children,
  pad = true,
  style = {},
}) {
  const { C } = S;

  return (
    <Card style={{ ...style }}>
      {title && (
        <div
          className={`compSection__header${pad ? " compSection__header--with-pad" : ""}`}
        >
          <div className="compSection__title">
            {title}
          </div>
          {action}
        </div>
      )}
      {pad ? (
        <div className={`compSection__body${!title ? " compSection__body--no-title" : ""}`}>
          {children}
        </div>
      ) : (
        children
      )}
    </Card>
  );
}
